import { apiClient } from "../api/apiclient";


export const createSimpleStory = (request, token) =>
  apiClient.post("/api/backlog", request, {
    headers: { Authorization: `Bearer ${token}` },
  });
export const getBacklogStories = (token) =>
  apiClient.get("/api/backlog/backlog", {
    headers: { Authorization: `Bearer ${token}` },
  });
export const updateStory = (id, formData, token) => {
  return apiClient.put(`/stories/${id}`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getAllStory = (token) =>
  apiClient.get("/stories", {
    headers: { Authorization: `Bearer ${token}` },
  });
export const downloadAttachment = async (filename, token) => {
  return apiClient.get(`/stories/files/${filename}`, {
    responseType: "blob",
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const getAllTeams = (token) =>
  apiClient.get("/teams", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getAllSprints = (token) =>
  apiClient.get("/sprints", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getAllUsers = (token) =>
  apiClient.get("/allusers", {
    headers: { Authorization: `Bearer ${token}` },
  });
export const deleteStoryAttachment = async (id, token) => {
  return apiClient.delete(`/stories/${id}/attachment`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// GET All Project Modules
export const getAllProjectModules = (token) =>
  apiClient.get("/project-modules", {
    headers: { Authorization: `Bearer ${token}` },
  });

  export const getModulesByStory = (token, storyId) =>
  apiClient.get(`/api/story-modules/modules-by-story/${storyId}`, {
    headers: { Authorization: `Bearer ${token}` },

  });
  export const assignStoryToSprint = (storyId, sprintId, token) =>
  apiClient.put(`/stories/${storyId}/assign-sprint/${sprintId}`, {}, {
    headers: { Authorization: `Bearer ${token}` },
  });
  // Get activity timeline (status changes, sprint moves, comments)
export const getStoryActivityTimeline = (token, storyId) =>
  apiClient.get(`/stories/${storyId}/activity`, {
    headers: { Authorization: `Bearer ${token}` },
  });

// Post a new comment
export const addStoryComment = (token, storyId, comment, files = []) => {
  const formData = new FormData();
  formData.append("comment", comment);
  (files || []).forEach((f) => formData.append("files", f));
  return apiClient.post(`/stories/${storyId}/comments`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

// Edit an existing comment (now supports adding new attachments too)
export const editStoryComment = (token, storyId, commentId, comment, files = []) => {
  const formData = new FormData();
  formData.append("comment", comment);
  (files || []).forEach((f) => formData.append("files", f));
  return apiClient.put(`/stories/${storyId}/comments/${commentId}`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
};


  export const moveStoryToBacklog = (storyId, token) =>
  apiClient.put(`/stories/${storyId}/move-to-backlog`, {}, {
    headers: { Authorization: `Bearer ${token}` },
  });
  
  export const updateBacklogOrder = (orderedStoryIds, token) =>
  apiClient.put(`/stories/reorder-backlog`, orderedStoryIds, {
    headers: { Authorization: `Bearer ${token}` },
  });
  